import { DatabaseEntities } from "../../../common/models/database-entities.model";

export class Lots extends DatabaseEntities<Lots> {
    itemId?: number;
    gestagroId?: string;
    name?: string;
    financialYear?: number;
    isListedLot?: boolean;
}
